export enum AttachedFile {
  ActionLink = 1,
  ProvidedLink,
  UploadedFile,
}
